import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ShoppingCart02 = function ShoppingCart02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.5001 17h10.8293c.9499 0 1.4249 0 1.812-.1716a1.9998 1.9998 0 0 0 .8433-.7038c.2381-.3502.3231-.8175.493-1.7522l1.3508-7.4293c.0589-.324.0884-.4859.0429-.6124a.5.5 0 0 0-.2198-.2633C21.5353 6 21.3707 6 21.0414 6H5.0001M2 2h1.3164c.2427 0 .364 0 .4622.0443a.5.5 0 0 1 .2121.1813c.0591.09.078.21.116.4496l2.7867 17.6496c.0378.2397.0568.3595.1159.4496a.5005.5005 0 0 0 .2121.1813C7.3196 21 7.441 21 7.6836 21H19"
    })
  }));
};
export default ShoppingCart02;